module.exports = __webpack_public_path__ + "static/media/deezer-head.cf3bae9c.png";